module.exports = {
  PANEL_SPEED_MILLISECONDS: 120   // Should match @panel-speed in variables.scss
};
